import { Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "button__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["button", [
      `button-${_ctx.type}`,
      {'button--icon' : _ctx.iconName.length},
      {'button--full' : _ctx.full},
    ]]),
    disabled: _ctx.disable
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({color: _ctx.iconColor}),
      class: _normalizeClass([`button-${_ctx.type}-icon`])
    }, [
      (_ctx.iconName.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
        : _createCommentVNode("", true)
    ], 6),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 10, _hoisted_1))
}